/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Formik } from 'formik';
import { Input, PhoneNumber } from '../../../ui/NewForm/index';
import * as style from './index.styles';
import * as Yup from 'yup';
import { Component } from 'react';
import { get } from 'lodash';
import { DEFAULT_COUNTRY } from '../../../../utils/constants';

import Cookies from 'universal-cookie';
import * as styles from './index.styles';
import Axios from 'axios';
import AnimFormButton, { FormStateArr } from '../../AnimFormButton';

export default class InputForm extends Component {
  cookies = new Cookies();
  channelCookie = this.cookies.get('channel_attrib') || 'Organic';

  state = {
    alert: { msgType: '', msg: '' },
    formState: FormStateArr.DEFAULT,
  };

  onSubmit = async (values, { setSubmitting, resetForm, setFieldError }) => {
    const PhoneNumberParameterName = get(
      this.props,
      'PhoneNumberParameterName',
      '',
    );
    const NameParameterName = get(this.props, 'NameParameterName', '');
    const SubmissionAPIURL = get(this.props, 'SubmissionAPIURL', '');
    const SuccessMessage = get(this.props, 'SuccessMessage', '');
    const ErrorMessage = get(this.props, 'ErrorMessage', '');
    const PhoneNumberInvalidErrorMessage = get(
      this.props,
      'PhoneNumberInvalidErrorMessage',
      '',
    );

    let submitData = {};
    submitData[PhoneNumberParameterName] =
      this.countryData.DialingCode + values.PhoneNumber;
    //submitData[PhoneNumberParameterName] = values.PhoneNumber;
    submitData[NameParameterName] = values.your_name;

    const urlParams = new URLSearchParams(window.location.search);
    const solution = urlParams.get('solution');
    if (solution) {
      submitData['solution'] = solution;
    }
    submitData['ChannelAttrib'] = this.channelCookie;
    submitData['DomainCountryISOCode2'] = this.countryData.CountryISOCode2;
    submitData['CountryISOCode3'] = this.countryData.CountryISOCode3;

    this.setState({
      alert: { msgType: '', msg: '' },
      formState: FormStateArr.PROGRESS,
    });

    let isPhoneValid = false;
    try {
      let CountryISOCode2 = this.countryData.CountryISOCode2;
      // let CountryISOCode3 = this.countryData.CountryISOCode3;
      let PhoneNumber = values.PhoneNumber;
      let apiURL = '/api/v1/form/validatecountryphonenumber';
      let postData = {
        countryISOCode2: CountryISOCode2,
        phoneNumber: PhoneNumber,
      };

      if (this.cancelTokenSource) {
        // Cancel request
        this.cancelTokenSource.cancel();
      }
      this.cancelTokenSource = Axios.CancelToken.source();
      let isValidNumber = await Axios.post(apiURL, postData);
      if (isValidNumber.status !== 200) {
        setFieldError('PhoneNumber', PhoneNumberInvalidErrorMessage);
        setSubmitting(false);
        this.setState({
          formState: FormStateArr.DEFAULT,
        });
      } else {
        isPhoneValid = true;
      }
    } catch (error) {
      setFieldError('PhoneNumber', PhoneNumberInvalidErrorMessage);
      setSubmitting(false);
      this.setState({
        formState: FormStateArr.DEFAULT,
      });
    }

    if (isPhoneValid) {
      try {
        const result = await Axios.post(SubmissionAPIURL, submitData);
        if (result.status == 200) {
          this.setState({
            alert: { msgType: 'success', msg: SuccessMessage },
            formState: FormStateArr.SUCCESS,
          });

          setSubmitting(false);
          resetForm();
        } else {
          this.setState({
            alert: { msgType: 'error', msg: ErrorMessage },
            formState: FormStateArr.ERROR,
          });

          setSubmitting(false);
        }
      } catch (error) {
        console.log('** error ', error);
        this.setState({
          alert: { msgType: 'error', msg: ErrorMessage },
          formState: FormStateArr.ERROR,
        });

        setSubmitting(false);
      }
    }
  };

  onFocus = () => {
    this.setState({
      formState: FormStateArr.DEFAULT,
      alert: { msgType: '', msg: '' },
    });
  };

  setCountryData = countryData => {
    this.countryData = countryData;
  };

  render() {
    const {
      alert: { msgType, msg },
      formState,
    } = this.state;

    const PhoneNumberRequiredErrorMessage = get(
      this.props,
      'PhoneNumberRequiredErrorMessage',
      '',
    );
    const PhoneNumberWatermark = get(this.props, 'PhoneNumberWatermark', '');
    const YourNameWatermark = get(this.props, 'YourNameWatermark', '');
    const CTAText = get(this.props, 'CTAText', '');

    const PhoneNumberOptions = get(this.props, 'PhoneNumberOptions', []);
    const defaultPhoneValue = get(
      this.props,
      'defaultPhoneValue',
      DEFAULT_COUNTRY,
    );

    const FormValidationSchema = Yup.object().shape({
      PhoneNumber: Yup.string()
        .trim()
        .required(PhoneNumberRequiredErrorMessage),
    });

    return (
      <Formik
        initialValues={{ your_name: '', PhoneNumber: '' }}
        validationSchema={FormValidationSchema}
        onSubmit={this.onSubmit}
      >
        {props => {
          const {
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          } = props;

          return (
            <form
              onSubmit={handleSubmit}
              className="contactform"
              data-formname="talkToAnExpertFormIncName"
            >
              <Input
                id="your_name"
                onChange={handleChange}
                error={errors.your_name && touched.your_name}
                errorMessage={errors.your_name}
                value={values.your_name}
                css={[styles.enquiryInput1]}
                placeholder={YourNameWatermark}
                onFocus={this.onFocus}
                disabled={isSubmitting}
              />

              <PhoneNumber
                options={PhoneNumberOptions}
                customCss={[styles.enquiryInput]}
                innerCss={styles.phoneNumberFieldCssProps1}
                id="PhoneNumber"
                defaultValue={defaultPhoneValue}
                placeholder={PhoneNumberWatermark}
                error={errors.PhoneNumber && touched.PhoneNumber}
                errorMessage={errors.PhoneNumber}
                inputProps={{
                  value: values.PhoneNumber,
                  disabled: isSubmitting,
                }}
                inputOnFocus={this.onFocus}
                onInit={({ countryData }) => this.setCountryData(countryData)}
                onChange={handleChange}
                onChangeProp={(_event, countryData) =>
                  this.setCountryData(countryData)
                }
                disabled={isSubmitting}
              />

              <AnimFormButton
                label={CTAText}
                formState={formState}
                buttonProps={{
                  type: 'submit',
                  disabled: isSubmitting,
                  onClick: this.onFocus,
                  css: [styles.enquirySubmit],
                }}
              />

              {msgType && (
                <div
                  css={[styles.msgBox, msgType && styles[msgType]]}
                  data-msg-type={msgType}
                >
                  {msg}
                </div>
              )}
            </form>
          );
        }}
      </Formik>
    );
  }
}
